import { Stack, Box, Typography } from "@mui/material";

/** Encabezado de sección de página: título, descripción opcional y acción a la derecha. */
export default function SectionHeader({ title, description, action, component = "h2", sx }) {
  return (
    <Stack
      direction={{ xs: "column", sm: "row" }}
      justifyContent="space-between"
      alignItems={{ xs: "flex-start", sm: "center" }}
      spacing={1}
      sx={{ mb: 1.5, ...sx }}
    >
      <Box>
        <Typography variant="h6" component={component} color="text.primary">
          {title}
        </Typography>
        {description && (
          <Typography variant="body2" color="text.secondary">
            {description}
          </Typography>
        )}
      </Box>
      {action}
    </Stack>
  );
}
